// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-path.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-path',
  version: 'solid',
  paths: [
    {
      d: 'M18.3744 13.7088A6.6 6.6 0 0 1 7.3332 16.668l-.3744-.3732h2.9196a.9.9 0 0 0 0-1.8H4.7868a.9.9 0 0 0-.9.9v5.0904a.9.9 0 0 0 1.8 0v-2.916l.372.372a8.4 8.4 0 0 0 14.0544-3.7656.9003.9003 0 0 0-1.7388-.468Zm1.476-4.4676a.9.9 0 0 0 .2628-.636V3.5148a.9.9 0 0 0-1.8 0V6.432l-.372-.372A8.4 8.4 0 0 0 3.8868 9.8256a.9.9 0 1 0 1.7376.4668A6.6 6.6 0 0 1 16.668 7.332l.3732.372h-2.9184a.9.9 0 0 0 0 1.8h5.0916a.9.9 0 0 0 .636-.2628',
      fillRule: 'evenodd',
    },
  ],
}
